<template>
  <div>
    <v-footer class="secondary" app tile padless fixed>
      <v-card flat tile width="100%" class="secondary ml-16">
        <v-card-text>
          <span class="colorText ml-2">
            Hôtel Dieu - TSA 80035 - 31 069 Toulouse Cedex - 05 61 77 83 70
          </span>
          <a
            target="_blank"
            v-bind:href="social.url"
            :key="social.name"
            v-for="social in socials"
          >
            <v-btn icon color="white" class="mx-3">
              <v-icon>{{ social.icon }}</v-icon>
            </v-btn>
          </a>

          <a
            target="_blank"
            v-bind:href="item.url"
            :key="item.name"
            v-for="item in items"
          >
            <v-btn text color="white" class="mx-4">{{ item.text }}</v-btn></a
          >
        </v-card-text>
      </v-card>
    </v-footer>
  </div>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      socials: [
        {
          name: "twitter",
          icon: "mdi-twitter",
          url: "https://twitter.com/europharmat",
        },
        {
          name: "linkedin",
          icon: "mdi-linkedin",
          url: "https://www.linkedin.com/company/euro-pharmat",
        },
      ],
      items: [
        {
          name: "partenaires",
          text: "LES PARTENAIRES",
          url: "//www.euro-pharmat.com/liens-partenaires",
        },
        {
          name: "contact",
          text: "CONTACT",
          url: "//www.euro-pharmat.com/contacter-l-equipe",
        },
        {
          name: "mentions légales",
          text: "MENTIONS LÉGALES",
          url: "//www.euro-pharmat.com/mentions",
        },
      ],
    };
  },
};
</script>

<style scoped>
.colorText {
  color: white;
}
</style>
